import React, { Fragment, useCallback, useEffect, useRef, useState } from "react"
import { FaTableCells } from "react-icons/fa6"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import classes from "./EditorTable.module.scss"

const table = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
  [20, 21, 22, 23, 24, 25, 26, 27, 28, 29],
  [30, 31, 32, 33, 34, 35, 36, 37, 38, 39],
  [40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
  [50, 51, 52, 53, 54, 55, 56, 57, 58, 59],
  [60, 61, 62, 63, 64, 65, 66, 67, 68, 69],
  [70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
  [80, 81, 82, 83, 84, 85, 86, 87, 88, 89],
  [90, 91, 92, 93, 94, 95, 96, 97, 98, 99]
]

const EditorTable = (props) => {
  const { editor } = props

  const [t] = useTranslation()

  const [row, setRow] = useState(-1)
  const [column, setColumn] = useState(-1)
  const [showDropdown, setShowDropdown] = useState(false)

  const ref = useRef(null)

  const handleMouseOver = (row, column) => {
    setRow(row)

    setColumn(column)
  }

  const handleClickCell = (row, column) => {
    editor
      .chain()
      .focus()
      .insertTable({ rows: row, cols: column })
      .run()

    setShowDropdown(false)

    setRow(-1)

    setColumn(-1)
  }

  const handleClickOutside = useCallback((e) => {
    if (ref.current?.contains(e.target)) return

    setShowDropdown(false)
  }, [])

  useEffect(() => {
    window.addEventListener("click", handleClickOutside)

    return () => {
      window.removeEventListener("click", handleClickOutside)
    }
  }, [])

  return (
    <div className={classes["container"]}>
      <div
        ref={ref}
        className={classes["dropdown-container"]}
      >
        <button
          onClick={() => setShowDropdown(prev => !prev)}
          className={classes["button"]}
        >
          <FaTableCells />
        </button>

        {
          showDropdown &&
          <div className={classes["dropdown"]}>
            <div
              onMouseLeave={() => handleMouseOver(-1, -1)}
              className={classes["table"]}
            >
              {table.map((tableRow, trIndex) =>
                <div
                  key={trIndex}
                  className={classes["row"]}
                >
                  {tableRow.map((tableColumn, tcIndex) =>
                    <div
                      key={tableColumn}
                      onMouseOver={() => handleMouseOver(trIndex, tcIndex)}
                      onClick={() => handleClickCell(trIndex, tcIndex)}
                      className={clsx(
                        classes["cell"],
                        tcIndex <= column && trIndex <= row && classes["active-cell"]
                      )}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        }
      </div>

      {
        editor.isActive("table") &&
        <Fragment>
          <div className={classes["separator"]} />
          <button
            className={classes["button-1"]}
            onClick={() => editor.chain().focus().addColumnAfter().run()}
          >
            {t("افزودن_ستون")}
          </button>
          <button
            className={classes["button-1"]}
            onClick={() => editor.chain().focus().addRowAfter().run()}
          >
            {t("افزودن_سطر")}
          </button>
          <button
            className={classes["button-1"]}
            onClick={() => editor.chain().focus().mergeCells().run()}
          >
            {t("ادغام_سلول")}
          </button>
          <button
            className={classes["button-1"]}
            onClick={() => editor.chain().focus().splitCell().run()}
          >
            {t("جداسازی_سلول")}
          </button>
          <button
            className={classes["button-1"]}
            onClick={() => editor.chain().focus().deleteColumn().run()}
          >
            {t("حذف_ستون")}
          </button>
          <button
            className={classes["button-1"]}
            onClick={() => editor.chain().focus().deleteRow().run()}
          >
            {t("حذف_سطر")}
          </button>
          <button
            className={classes["button-1"]}
            onClick={() => editor.chain().focus().deleteTable().run()}
          >
            {t("حذف_جدول")}
          </button>
        </Fragment>
      }
    </div>
  )
}

export default EditorTable